"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGuid = isGuid;
exports.newGuid = newGuid;
var CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
var validator = new RegExp("^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$", "i");
function isGuid(value) {
    return value && validator.test(value);
}
/*
 * Generate a random NewGuid.
 *
 * EXAMPLES:
 *   // No arguments  - returns RFC4122, version 4 ID
 *   >>> guid.newGuid()
 *   '92329D39-6F5C-4520-ABFC-AAB64544E172'
 *
 *   // One argument - returns ID of the specified length
 *   >>> guid.newGuid(15)     // 15 character ID (default base=62)
 *   'VcydxgltxrVZSTV'
 *
 *   // Two arguments - returns ID of the specified length, and radix. (Radix must be <= 62)
 *   >>> guid.newGuid(8, 2)  // 8 character ID (base=2)
 *   '01001010'
 *   >>> guid.newGuid(8, 10) // 8 character ID (base=10)
 *   '47473046'
 *   >>> guid.newGuid(8, 16) // 8 character ID (base=16)
 *   '098F4D35'
 */
function newGuid(len, radix) {
    radix = radix || CHARS.length;
    var i, uuid = [];
    if (len) {
        // Compact form
        for (i = 0; i < len; i++)
            uuid[i] = CHARS[0 | (Math.random() * radix)];
    }
    else {
        // rfc4122, version 4 form
        uuid[14] = "4";
        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
        // Fill in random data.  At i==19 set the high bits of clock sequence as per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++)
            if (!uuid[i]) {
                var r = 0 | (Math.random() * 16);
                uuid[i] = CHARS[i === 19 ? (r & 0x3) | 0x8 : r & 0xf];
            }
    }
    return uuid.join("");
}
